import SyncAltIcon from "@mui/icons-material/SyncAlt";
import type { FC, MouseEventHandler } from "react";

import { FilterChip } from "~/components/UI/FilterChip";

interface SpreadFilterButtonProps {
  label: string;
  isDefaultSelected: boolean;
  locked?: boolean;
  onOpen: MouseEventHandler<HTMLButtonElement>;
  onClear: () => void;
}

export const SpreadFilterButton: FC<SpreadFilterButtonProps> = ({
  label,
  isDefaultSelected,
  locked,
  onOpen,
  onClear,
}) => (
  <FilterChip
    label="Spread"
    icon={<SyncAltIcon fontSize="inherit" />}
    valueLabel={isDefaultSelected ? undefined : label}
    locked={locked}
    onClick={onOpen}
    onClear={onClear}
  />
);
